/**
 * Simple extension of semantic Grid to add a little more functionality
 */
import React from 'react'
import { Grid as SemanticGrid } from '@adc/ui-core'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const Grid = props => {
  const { children, className, relaxed, ...rest } = props
  const newClassName = !relaxed ? cx('relaxed-default', className) : className

  return (
    <SemanticGrid {...rest} relaxed={relaxed} className={newClassName}>
      {children}
    </SemanticGrid>
  )
}

Grid.propTypes = SemanticGrid.propTypes
Grid.Row = SemanticGrid.Row
Grid.Column = SemanticGrid.Column
Grid._meta = SemanticGrid._meta

export default Grid
